import {actionContactDeleteCompleted, actionContactSaveCompleted} from "../store/customers/actions";
import {BaseService} from "./BaseService";
import {ContactsAPI} from "../api/ContactsAPI";
import {Contact} from "../models/Contact";
import {ErrorService} from "./ErrorService";
import {actionUpdateTabStateItem} from "../store/tabs/actions";
import {Category} from "../models/Category";
import {CategoriesAPI} from "../api/CategoriesAPI";
import {actionCategoryFetchAllCompleted} from "../store/categories";
import {actionToastrInfo} from "../store/global";

export default class ContactsService extends BaseService {

	static save(contact: Contact, index: number) {

		let contactsAPI: ContactsAPI = new ContactsAPI(contact.customerId)

		if (contact.id) {
			contactsAPI.put(ContactsService.contactToRequest(contact)).then(ContactsService.processResponse).then(
				(data) => {
					actionContactSaveCompleted(ContactsService.fromAPIContact(data), index)
					actionToastrInfo("Info", "Kontak je uspešno snimljen")
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			contactsAPI.post(ContactsService.contactToRequest(contact)).then(ContactsService.processResponse).then(
				(data) => {
					actionContactSaveCompleted(ContactsService.fromAPIContact(data), index)
					actionUpdateTabStateItem(ContactsService.fromAPIContact(data), 'contacts', index)
					actionToastrInfo("Info", "Kontak je uspešno snimljen")
				}
			).catch(error => ErrorService.handleError(error))

		}
	}

	static delete(contact: Contact) {

		let contactsAPI: ContactsAPI = new ContactsAPI(contact.customerId)

		contactsAPI.delete(ContactsService.contactToRequest(contact)).then(ContactsService.processResponse).then(
			(data) => {
				actionContactDeleteCompleted(contact)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static fromAPIContact(apiContact: any): Contact {
		let contact = new Contact();

		contact.id = apiContact.id;
		contact.title = apiContact.name;
		contact.email = apiContact.email;
		contact.phone = apiContact.phone;
		contact.customerId = apiContact.customerId;

		return contact;
	}

	static contactToRequest(contact: Contact): any {

		let contactRequest: any = {};

		if (contact.id)
			contactRequest.id = contact.id;

		contactRequest.name = contact.title;
		contactRequest.email = contact.email;
		contactRequest.phone = contact.phone;
		contactRequest.customerId = contact.customerId;

		return contactRequest
	}

	static fromAPIList(apiList: any): Contact[] {
		const localList: Contact[] = apiList.map((apiItem: any) => ContactsService.fromAPIContact(apiItem));
		return localList
	}
}
